// Vitafive Vitamin Quiz - Shopify Integration
// This file handles the quiz functionality and Shopify cart integration

class VitafiveQuiz {
  constructor(sectionId, config) {
    this.sectionId = sectionId;
    this.config = config;
    this.currentScreen = 'welcome';
    this.currentQuestionIndex = 0;
    this.answers = [];
    this.isProcessing = false;
    
    this.init();
  }

  init() {
    this.renderQuiz();
    this.bindEvents();
    
    // Analytics
    if (this.config.enableAnalytics && typeof gtag !== 'undefined') {
      gtag('event', 'quiz_loaded', {
        'page_location': window.location.href,
        'quiz_type': 'vitamin_personality'
      });
    }
  }

  renderQuiz() {
    const container = document.getElementById(`quiz-root-${this.sectionId}`);
    if (!container) return;

    let html = '';

    switch (this.currentScreen) {
      case 'welcome':
        html = this.renderWelcomeScreen();
        break;
      case 'quiz':
        html = this.renderQuizScreen();
        break;
      case 'results':
        html = this.renderResultsScreen();
        break;
    }

    container.innerHTML = html;
    this.bindCurrentScreenEvents();
  }

  renderWelcomeScreen() {
    return `
      <div class="quiz-welcome-screen">
        <div class="quiz-welcome-content">
          <div class="quiz-logo">
            <div class="quiz-logo-icon">
              <svg viewBox="0 0 32 32" fill="none">
                <circle cx="16" cy="16" r="15" fill="url(#vitafiveGradient)" />
                <ellipse cx="12" cy="10" rx="3" ry="4" fill="#ffffff" opacity="0.9" />
                <ellipse cx="20" cy="12" rx="2.5" ry="3.5" fill="#ffffff" opacity="0.8" />
                <ellipse cx="16" cy="20" rx="3.5" ry="4.5" fill="#ffffff" opacity="0.9" />
                <ellipse cx="10" cy="18" rx="2" ry="3" fill="#ffffff" opacity="0.7" />
                <ellipse cx="22" cy="20" rx="2.5" ry="3" fill="#ffffff" opacity="0.8" />
                <path d="M13 8 L16 14 L19 8" stroke="#4ade80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
                <circle cx="8" cy="12" r="1" fill="#fbbf24" opacity="0.8" />
                <circle cx="24" cy="16" r="0.8" fill="#f472b6" opacity="0.7" />
                <circle cx="12" cy="24" r="0.6" fill="#a78bfa" opacity="0.6" />
                <defs>
                  <linearGradient id="vitafiveGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#4ade80" />
                    <stop offset="50%" stop-color="#5eead4" />
                    <stop offset="100%" stop-color="#34d399" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="quiz-brand-text">
              <span class="quiz-brand-name">${this.config.brandName}</span>
              <span class="quiz-brand-tagline">WELLNESS</span>
            </div>
          </div>
          
          <h1 class="quiz-welcome-title">${this.config.welcomeTitle}</h1>
          <p class="quiz-welcome-subtitle">${this.config.welcomeSubtitle}</p>
          
          ${this.config.showTrustIndicators ? `
            <div class="quiz-trust-indicators">
              <div class="quiz-trust-item">
                <span class="quiz-star">⭐</span>
                <span>4.9/5</span>
              </div>
              <div class="quiz-trust-dot">•</div>
              <div class="quiz-trust-item">10k+ happy customers</div>
              <div class="quiz-trust-dot">•</div>
              <div class="quiz-trust-item">🇺🇸 Made in USA</div>
            </div>
          ` : ''}
          
          <button class="quiz-start-button" data-action="start">
            <span>Start My Quiz</span>
            <span class="quiz-sparkle">✨</span>
          </button>
          
          <p class="quiz-welcome-hint">Takes less than 2 minutes • No email required</p>
        </div>
      </div>
    `;
  }

  renderQuizScreen() {
    const question = this.config.questions[this.currentQuestionIndex];
    const progress = ((this.currentQuestionIndex + 1) / this.config.questions.length) * 100;

    return `
      <div class="quiz-screen">
        ${this.config.showProgressDots ? `
          <div class="quiz-progress">
            <div class="quiz-progress-bar">
              <div class="quiz-progress-fill" style="width: ${progress}%"></div>
            </div>
            <div class="quiz-progress-text">${this.currentQuestionIndex + 1} of ${this.config.questions.length}</div>
          </div>
        ` : ''}
        
        <div class="quiz-card-container">
          <div class="quiz-swipe-indicators">
            <div class="quiz-indicator quiz-indicator-left" id="quiz-indicator-left">
              <span>No thanks</span>
              <span>👈</span>
            </div>
            <div class="quiz-indicator quiz-indicator-right" id="quiz-indicator-right">
              <span>👉</span>
              <span>Yes please!</span>
            </div>
          </div>
          
          <div class="quiz-card quiz-card-${question.gradient}" 
               data-question-id="${question.id}"
               id="quiz-current-card">
            <div class="quiz-card-icon">
              ${this.getIconSVG(question.icon)}
            </div>
            <h3 class="quiz-card-text">${question.text}</h3>
            <p class="quiz-card-instruction">Swipe right if this sounds like you ✨</p>
            
            ${this.config.enableDesktopButtons ? `
              <div class="quiz-card-buttons">
                <button class="quiz-button quiz-button-no" data-action="answer" data-answer="no">No thanks</button>
                <button class="quiz-button quiz-button-yes" data-action="answer" data-answer="yes">Yes please!</button>
              </div>
            ` : ''}
          </div>
          
          <div class="quiz-instructions-below">
            <div class="quiz-mobile-hint">
              <span>←</span>
              <span>Swipe to answer</span>
              <span>→</span>
            </div>
            <div class="quiz-desktop-hint">
              ${this.config.enableDesktopButtons ? 'Click the buttons above or swipe to answer' : 'Drag the card left or right to answer'}
            </div>
          </div>
        </div>
        
        ${this.isProcessing ? `
          <div class="quiz-loading-overlay">
            <div class="quiz-loading-spinner"></div>
            <p>Processing...</p>
          </div>
        ` : ''}
      </div>
    `;
  }

  renderResultsScreen() {
    const result = this.calculateResult();
    const products = this.config.results[result.type]?.products || [];

    return `
      <div class="quiz-results-screen">
        <div class="quiz-results-content">
          <div class="quiz-result-icon">
            ${this.getIconSVG(result.icon)}
          </div>
          
          <div class="quiz-result-header">
            <div class="quiz-congrats">
              <span class="quiz-sparkle">✨</span>
              <span>Your perfect match is...</span>
              <span class="quiz-sparkle">✨</span>
            </div>
            <h1 class="quiz-result-title">${result.title}</h1>
          </div>
          
          <p class="quiz-result-description">${result.description}</p>
          
          ${this.config.showProductImages && products.length > 0 ? `
            <div class="quiz-products-section">
              <h3 class="quiz-products-title">Your Recommended Combo:</h3>
              <div class="quiz-products-grid">
                ${products.map(product => `
                  <div class="quiz-product-item">
                    <div class="quiz-product-image">
                      <img src="${product.image}" alt="${product.name}" loading="lazy">
                    </div>
                    <p class="quiz-product-name">${product.name}</p>
                  </div>
                `).join('')}
              </div>
              
              <div class="quiz-product-summary">
                <div class="quiz-summary-header">
                  <div class="quiz-summary-icon">
                    ${this.getIconSVG(result.icon)}
                  </div>
                  <span class="quiz-perfect-match-badge">Perfect Match</span>
                </div>
                <div class="quiz-summary-details">
                  <h4>Complete Wellness Pack</h4>
                  <div class="quiz-summary-info">
                    <span>${products.length} products</span>
                    <span>30-day supply</span>
                  </div>
                </div>
              </div>
            </div>
          ` : ''}
          
          <div class="quiz-result-actions">
            <button class="quiz-add-to-cart-button" data-action="add-to-cart">
              <span class="quiz-cart-icon">🛒</span>
              <span>Add to Cart</span>
            </button>
            <button class="quiz-restart-button" data-action="restart">
              <span class="quiz-restart-icon">↻</span>
              <span>Take Quiz Again</span>
            </button>
          </div>
          
          <p class="quiz-result-hint">✨ Over 10,000 people love this combo ✨</p>
        </div>
      </div>
    `;
  }

  bindEvents() {
    // Touch events for swipe functionality
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    document.addEventListener('touchstart', (e) => {
      const card = document.getElementById('quiz-current-card');
      if (!card || !card.contains(e.target)) return;
      
      startX = e.touches[0].clientX;
      isDragging = true;
      card.style.transition = 'none';
    });

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      
      currentX = e.touches[0].clientX;
      const deltaX = currentX - startX;
      const card = document.getElementById('quiz-current-card');
      
      if (card) {
        card.style.transform = `translateX(${deltaX}px) rotate(${deltaX * 0.1}deg)`;
        
        // Update indicators
        const leftIndicator = document.getElementById('quiz-indicator-left');
        const rightIndicator = document.getElementById('quiz-indicator-right');
        
        if (leftIndicator) {
          leftIndicator.style.opacity = deltaX < -30 ? '1' : '0';
        }
        if (rightIndicator) {
          rightIndicator.style.opacity = deltaX > 30 ? '1' : '0';
        }
      }
    });

    document.addEventListener('touchend', () => {
      if (!isDragging) return;
      
      const deltaX = currentX - startX;
      const card = document.getElementById('quiz-current-card');
      
      if (card) {
        card.style.transition = 'transform 0.3s ease';
        
        if (Math.abs(deltaX) > 80) {
          // Swipe detected
          const direction = deltaX > 0 ? 'right' : 'left';
          this.handleAnswer(direction === 'right' ? 'yes' : 'no');
        } else {
          // Snap back
          card.style.transform = 'translateX(0) rotate(0deg)';
        }
      }
      
      // Reset indicators
      const leftIndicator = document.getElementById('quiz-indicator-left');
      const rightIndicator = document.getElementById('quiz-indicator-right');
      
      if (leftIndicator) leftIndicator.style.opacity = '0';
      if (rightIndicator) rightIndicator.style.opacity = '0';
      
      isDragging = false;
    });
  }

  bindCurrentScreenEvents() {
    // Button click events
    document.querySelectorAll('[data-action]').forEach(button => {
      button.addEventListener('click', (e) => {
        const action = e.target.closest('[data-action]').dataset.action;
        
        switch (action) {
          case 'start':
            this.startQuiz();
            break;
          case 'answer':
            const answer = e.target.closest('[data-action]').dataset.answer;
            this.handleAnswer(answer);
            break;
          case 'add-to-cart':
            this.addToCart();
            break;
          case 'restart':
            this.restartQuiz();
            break;
        }
      });
    });
  }

  startQuiz() {
    this.currentScreen = 'quiz';
    this.currentQuestionIndex = 0;
    this.answers = [];
    this.renderQuiz();
    
    if (this.config.enableAnalytics && typeof gtag !== 'undefined') {
      gtag('event', 'quiz_start', {
        'quiz_type': 'vitamin_personality'
      });
    }
  }

  handleAnswer(answer) {
    if (this.isProcessing) return;
    
    this.isProcessing = true;
    const question = this.config.questions[this.currentQuestionIndex];
    
    this.answers.push({
      questionId: question.id,
      answer: answer
    });

    // Analytics
    if (this.config.enableAnalytics && typeof gtag !== 'undefined') {
      gtag('event', 'quiz_answer', {
        'question_id': question.id,
        'question_number': this.currentQuestionIndex + 1,
        'answer': answer,
        'question_text': question.text
      });
    }

    // Animate card exit
    const card = document.getElementById('quiz-current-card');
    if (card) {
      const direction = answer === 'yes' ? 1 : -1;
      card.style.transform = `translateX(${direction * 300}px) rotate(${direction * 15}deg)`;
      card.style.opacity = '0';
    }

    setTimeout(() => {
      if (this.currentQuestionIndex < this.config.questions.length - 1) {
        this.currentQuestionIndex++;
        this.isProcessing = false;
        this.renderQuiz();
      } else {
        this.showResults();
      }
    }, 600);
  }

  showResults() {
    this.currentScreen = 'results';
    this.isProcessing = false;
    
    const result = this.calculateResult();
    
    if (this.config.enableAnalytics && typeof gtag !== 'undefined') {
      gtag('event', 'quiz_complete', {
        'quiz_type': 'vitamin_personality',
        'result_type': result.type,
        'total_questions': this.config.questions.length
      });
    }
    
    this.renderQuiz();
  }

  calculateResult() {
    const scores = {
      wellness: 0,
      relaxation: 0,
      'womens-health': 0
    };

    this.answers.forEach(answer => {
      if (answer.answer === 'yes') {
        const question = this.config.questions.find(q => q.id === answer.questionId);
        if (question && scores.hasOwnProperty(question.category)) {
          scores[question.category]++;
        }
      }
    });

    let topCategory = 'wellness';
    let maxScore = scores.wellness;

    if (scores.relaxation > maxScore) {
      topCategory = 'relaxation';
      maxScore = scores.relaxation;
    }
    
    if (scores['womens-health'] > maxScore) {
      topCategory = 'womens-health';
    }

    const resultKey = topCategory === 'womens-health' ? 'womensHealth' : topCategory;
    return {
      type: topCategory,
      title: this.config.results[resultKey]?.title || 'The Wellness Warrior',
      description: this.config.results[resultKey]?.description || 'You\'re all about that balanced lifestyle!',
      icon: topCategory === 'relaxation' ? 'moon' : topCategory === 'womens-health' ? 'shield' : 'heart'
    };
  }

  async addToCart() {
    const result = this.calculateResult();
    const resultKey = result.type === 'womens-health' ? 'womensHealth' : result.type;
    const products = this.config.results[resultKey]?.products || [];

    if (products.length === 0) {
      alert('Products not configured. Please contact support.');
      return;
    }

    try {
      const items = products
        .filter(product => product.handle)
        .map(product => ({
          id: product.handle,
          quantity: 1
        }));

      if (items.length === 0) {
        throw new Error('No valid product handles found');
      }

      switch (this.config.cartType) {
        case 'ajax':
          await this.addToCartAjax(items);
          break;
        case 'redirect':
          this.addToCartRedirect(items);
          break;
        case 'drawer':
          await this.addToCartDrawer(items);
          break;
        default:
          await this.addToCartAjax(items);
      }

      // Analytics
      if (this.config.enableAnalytics && typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart_quiz', {
          'quiz_result': result.type,
          'products': products.map(p => p.handle).join(','),
          'currency': 'USD',
          'value': products.length * 29.99
        });
      }

    } catch (error) {
      console.error('Add to cart failed:', error);
      alert('Sorry, there was an error adding items to your cart. Please try again.');
    }
  }

  async addToCartAjax(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    // Trigger cart update event for theme compatibility
    if (typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new Event('cart:updated'));
    }
    
    alert(`Added ${items.length} item(s) to your cart! 🛒✨`);
    return result;
  }

  addToCartRedirect(items) {
    const params = items.map(item => `${item.id}:${item.quantity}`).join(',');
    window.location.href = `/cart/add?id=${params}&return_to=/cart`;
  }

  async addToCartDrawer(items) {
    await this.addToCartAjax(items);
    
    // Try to open cart drawer (theme-specific)
    if (typeof window.theme?.cartDrawer?.open === 'function') {
      window.theme.cartDrawer.open();
    } else if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    } else {
      // Fallback to alert
      alert(`Added ${items.length} item(s) to your cart! 🛒✨`);
    }
  }

  restartQuiz() {
    this.currentScreen = 'welcome';
    this.currentQuestionIndex = 0;
    this.answers = [];
    this.isProcessing = false;
    this.renderQuiz();

    if (this.config.enableAnalytics && typeof gtag !== 'undefined') {
      gtag('event', 'quiz_restart', {
        'previous_result': this.calculateResult().type
      });
    }
  }

  getIconSVG(iconName) {
    const icons = {
      heart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,
      zap: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2"/></svg>`,
      moon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>`,
      sparkles: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l1.09 3.26L16 4 13.91 5.74 15 9l-3-1-3 1 1.09-3.26L8 4l2.91 1.26L12 2z"/><path d="M21 12l-1.09-3.26L17 10l2.09-1.74L18 5l3 1 3-1-1.09 3.26L25 10l-2.91-1.26L21 12z"/><path d="M7 21l0.54-1.63L9 19l-1.46-0.87L7 17l-1.5 0.5L4 17l0.54 1.63L3 19l1.54 0.37L7 21z"/></svg>`,
      shield: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`
    };
    
    return icons[iconName] || icons.heart;
  }
}

// Initialize quiz when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Find all quiz sections and initialize them
  document.querySelectorAll('[data-section-id]').forEach(section => {
    const sectionId = section.dataset.sectionId;
    const config = window.VitafiveQuizConfig?.[sectionId];
    
    if (config) {
      new VitafiveQuiz(sectionId, config);
    }
  });
});